import { baseApi } from '@/utils/api.js';

const favoritesApi = baseApi.enhanceEndpoints({ addTagTypes: ['Favorites'] }).injectEndpoints({
  endpoints: (builder) => ({
    getFavorites: builder.query({
      query: ({ householdId }) => ({
        url: `/h/${householdId}/recipes/favorites`,
        method: 'GET',
      }),
      providesTags: (result, error, arg) => [
        { type: 'Favorites', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    addFavorite: builder.mutation({
      query: ({ householdId, recipeId }) => ({
        url: `/h/${householdId}/recipes/${recipeId}/favorite`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Favorites', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    removeFavorite: builder.mutation({
      query: ({ householdId, recipeId }) => ({
        url: `/h/${householdId}/recipes/${recipeId}/favorite`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Favorites', id: 'LIST', householdId: arg.householdId }
      ],
    }),
  }),
});

export const {
  useGetFavoritesQuery,
  useAddFavoriteMutation,
  useRemoveFavoriteMutation,
} = favoritesApi;

